import { green, purple } from '@material-ui/core/colors';
const customImageInputStyle = theme => ({
    hidden: { display: "none" },
    container: {
        margin: "auto"
    },
    box: {
        width: "100%",
        display: "grid",
        cursor: "pointer",
        marginBottom: "20px"
    },
    buttonClear: {
        marginRight: "20px !important",
    },
    btnSave: {
        backgroundColor: "#417557",
        boxShadow: "none",
        color: "#fff",
        "&:hover": {
            background: "#447557",
        },
    },
    title: {
        margin: "auto",
        display: "flex",
        justifyContent: "center",
        //fontFamily: 'Roboto Slab',
        //fontWeight:'bold',
        padding: theme.spacing.unit
    },
    bigAvatar: {
        margin: "auto",
        border: 'none',
        width: '100%',
        height: 'auto',
        borderRadius: '0',
        backgroundColor: 'transparent !important',
    },
    avatarThumb: {
        maxWidth: '100%',
        maxHeight: 'auto',
        marginBottom: '20px',
        backgroundColor: 'transparent !important',
    },
    primaryBack: {
        backgroundColor: 'transparent',
    },
    whiteBack: {
        background: "white"
    },

    errorBack: { background: theme.palette.error.main }
});
export default customImageInputStyle;